import { render, staticRenderFns } from "./IkEntityForm.vue?vue&type=template&id=7c7c1a9c&scoped=true&"
import script from "./IkEntityForm.vue?vue&type=script&lang=js&"
export * from "./IkEntityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7c1a9c",
  null
  
)

export default component.exports